<!-- src/views/demand/demand-cooperation-list.vue -->
<template>
	<div class="app-body">
		<div class="a-flex-rsbc a-ptb-6">
			<span class="a-fs-16">合作意向</span>
			<!-- <el-button icon="el-icon-upload2" class="s-btn-exp">导出</el-button> -->
		</div>

		<el-card class="el-main">
			<le-search-form id="leSearch" @reset="handlerRest" @search="handlerSearch">
				<le-input label="需求名称" v-model="pageParam.params.title" placeholder="请输入内容" />
				<le-select-local-search label="需求类型" v-model="pageParam.params.businessType" :options="businessTypeDic" />
				<le-select-local-search label="意向状态" v-model="pageParam.params.intentionStatus" :options="intentionStatusDic" />
                <le-input label="意向人手机" v-model="pageParam.params.intentUserPhone" placeholder="请输入内容" />
				<le-date-range 
					label="发起时间" 
					:minDate.sync="pageParam.params.startTime" 
					:maxDate.sync="pageParam.params.endTime" 
					:defaultTime="['00:00:00','23:59:59']"
					valueFormat="yyyy-MM-dd HH:mm:ss" />
			</le-search-form>
			<le-pagview @setData="setTableData" :pageParam="pageParam" ref="cooperationPage" :isFixed="true" :tableRef="$refs.cooperationList">
				<el-table :data="tableData" :highlight-current-row="true" ref="cooperationList" style="width: 100%" v-sticky="{ top: 0, parent:'.el-card__body' }">
					<!-- 需求类型 -->
					<el-table-column prop="businessType" label="需求类型" width="120" >
						<template slot-scope="{ row }">
							<span>{{ row.businessType | initDic(businessTypeDic) }}</span>
						</template>
					</el-table-column>
                    <!-- 需求名称 -->
					<el-table-column prop="title" label="需求名称" min-width="120" >
						<template slot-scope="{ row }">
							<span>{{ row.title }}</span>
						</template>
					</el-table-column>
					<!-- 合作意向描述 -->
					<el-table-column prop="content" label="意向描述" width="400" >
						<template slot-scope="{ row }">
							<div class="a-flex-rfsc">
                                <span style="width: 360px" class="textOver1">{{ row.content }}</span>
                                <el-tooltip placement="top">
                                    <div slot="content" style="width: 300px;">{{ row.content }}</div>
                                    <el-button type="text" >查看</el-button>
                                </el-tooltip>
                            </div>
						</template>
					</el-table-column>

					<!-- 图片附件 -->
					<el-table-column prop="attachmentUrls" label="图片附件" min-width="140">
						<template slot-scope="{ row }">
                            <div v-if="row.attachmentUrls && getImageList(row.attachmentUrls).length > 0" class="image-attachment a-flex-rfsc">
                                <el-image 
                                    :src="getImageList(row.attachmentUrls)[0]" 
                                    :preview-src-list="getImageList(row.attachmentUrls)"
                                    fit="cover"
                                    style="width: 80px; height: 80px;border-radius: 6px">
                                </el-image>
                                <span class="image-count a-ml-10">{{ getImageCount(row.attachmentUrls) }}张</span>
                            </div>
                        </template>
					</el-table-column>
                    <!-- 状态 -->
					<el-table-column prop="status" label="意向状态" width="100" >
						<template slot-scope="{ row }">
							<span :class="['status-tag', getStatusClass(row.status)]">
                                {{ row.status | initDic(intentionStatusDic) }}
							</span>
						</template>
					</el-table-column>
					<!-- 意向人 -->
					<el-table-column label="意向人" width="180" >
						<template slot-scope="{ row }">
							<div class="intention-person">
								<div v-if="row.intentUserName">{{ row.intentUserName }}</div>
								<div class="a-ml-10">{{ row.intentUserPhone || '-' }}</div>
							</div>
						</template>
					</el-table-column>

					<!-- 申请时间 -->
					<el-table-column prop="createTime" label="发起意向时间" width="180" >
						<template slot-scope="{ row }">
							<span>{{ row.createTime }}</span>
						</template>
					</el-table-column>
					<!-- 操作 -->
					<el-table-column label="操作" width="100" fixed="right" >
						<template slot-scope="{ row }">
							<el-button v-if="row.status === 0" type="text" @click="handleAudit(row)">审核</el-button>
							<el-button type="text" @click="handleDelete(row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</le-pagview>
		</el-card>

		<!-- 审核弹窗 -->
		<AuditDialog 
			:visible.sync="isAuditDialogVisible" 
			:initial-data="{
				auditResult: currentAuditRow.auditResult || 'pass',
				auditRemark: currentAuditRow.auditRemark || ''
			}"
			@submit="handleAuditSubmit"
		/>
	</div>
</template>

<script>
import util from "../../utils/util.js";
import AuditDialog from '../demand/components/audit-dialog.vue';

export default {
	name: 'DemandCooperationList',
	components: {
		AuditDialog
	},
	data() {
		return {
			util: util,
			tableData: [],
			pageParam: {
				url: this.$Config.apiUrl.intentionBackPage,
				method: "post",
				params: {
					title: "",
					businessType: "",
					intentionStatus: "",
					intentUserPhone: "",
					startTime: "",
					endTime: "",
				},
                freshCtrl: 1
			},
			// 控制审核弹窗显示
			isAuditDialogVisible: false,
			// 当前审核行的数据
			currentAuditRow: {},
			// 需求类型选项
			businessTypeDic: [],
			// 意向状态选项
			intentionStatusDic: [],
		};
	},
	mounted() {
        this.$getDic('demandBusinessType','select').then(res=>{ this.businessTypeDic = res; })
        this.$getDic('IntentStatus','select').then(res=>{ this.intentionStatusDic = res; })
	},
	methods: {
		// 设置表格数据
		setTableData(data) {
			this.tableData = data || [];
		},

		// 搜索
		handlerSearch() {
			this.$refs['cooperationPage'].pageNum = 1
			this.pageParam.freshCtrl++;
		},

		// 重置
		handlerRest() {
			this.pageParam.params = {
				title: "",
				businessType: "",
				intentionStatus: "",
				intentUserPhone: "",
				startTime: "",
				endTime: "",
			};
			this.handlerSearch()
		},
		// 获取状态样式类
		getStatusClass(status) {
			const statusMap = {
				0: 'pending',    // 待审核
				1: 'passed',     // 已通过
				2: 'rejected',   // 已拒绝
				3: 'cancelled'   // 已取消
			};
			return statusMap[status] || '';
		},

		// 审核操作
		handleAudit(row) {
			this.currentAuditRow = row;
			this.isAuditDialogVisible = true;
		},

		// 删除操作
		handleDelete(row) {
			this.$confirm('确定要删除该合作意向吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$Axios._post({
					url: this.$Config.apiUrl.supplyBackIntentionDelete,
					method: 'post',
					params: {
						id: row.id
					}
				}).then(() => {
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
					// 刷新列表
					this.pageParam.freshCtrl++;
				})
			})
		},

		// 处理审核提交
		handleAuditSubmit(data) {
			this.$Axios._post({
				url: this.$Config.apiUrl.supplyBackIntentionAudit,
				method: 'post',
				params: {
					id: this.currentAuditRow.id,
					auditStatus: data.auditStatus,
					auditRemark: data.auditRemark
				}
			}).then(() => {
				this.$message.success('审核成功');
				// 刷新列表
				this.pageParam.freshCtrl++;
			})
		},
        // 获取图片数量
        getImageCount(imageUrls) {
            if (!imageUrls) return 0;
            try {
                const images = JSON.parse(imageUrls);
                return Array.isArray(images) ? images.length : 0;
            } catch (e) {
                return 0;
            }
        },

        // 获取图片列表
        getImageList(imageUrls) {
            if (!imageUrls) return [];
            try {
                const images = JSON.parse(imageUrls);
                return Array.isArray(images) ? images : [];
            } catch (e) {
                return [];
            }
        },
	}
};
</script>

<style scoped lang="scss">
.image-attachment {
	cursor: pointer;
}

.intention-person {
	line-height: 1.5;
	
	.phone-text {
		font-size: 12px;
		color: #999;
		margin-top: 4px;
	}
}

.image-count {
	font-size: 12px;
	color: #999;
	margin-top: 4px;
    white-space: nowrap;
}

.status-tag {
	padding: 2px 8px;
	border-radius: 4px;
	font-size: 12px;
}

.status-tag.pending {
	background-color: #fff3e0;
	color: #f57c00;
}

.status-tag.passed {
	background-color: #e8f5e9;
	color: #388e3c;
}

.status-tag.rejected {
	background-color: #ffebee;
	color: #d32f2f;
}

.status-tag.cancelled {
	background-color: #f5f5f5;
	color: #999;
}

.el-button--mini {
	padding: 4px 8px;
	font-size: 12px;
}

/* 操作按钮间距 */
.el-button + .el-button {
	margin-left: 8px;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 0 !important;
    height: 0 !important;
}
/deep/ .el-table__fixed, /deep/ .el-table__fixed-right{
    height: 100% !important;
}
</style>